import Spinner from "../../../shared/UxbiSpinner";
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Accordion } from "react-bootstrap";
import AsyncSelectERP from "../../common/AsyncSelectERP";
import {
  getEmpresas,
  getZonas,
  getGruposCliente,
  getFuentesProspecto,
  getAgentesVentas,
  getProbabilidadesCierre,
  getClientesSimilares,
  getClientes,
} from "../../../api/uxbi";
import { getCurrentUser } from "../../utils/getCurrentUser";
import WdowConfirm from "../../utils/WdowConfirm";
import { toast } from "react-toastify";

export default function ProspectoFormModal({
  show,
  onHide,
  onSubmit,
  record,
  isEditMode = false,
  onCreateSeguimiento,
}) {
  const session = getCurrentUser();
  const initialState = {
    empresa: null,
    razonSocial: "",
    clave: "",
    nombreComercial: "",
    rfc: "",
    zona: null,
    grupoCliente: null,
    fuente: null,
    agenteVentas: null,
    clasificacion: "",
    contactoNombre: "",
    email: "",
    telefono: "",
    extension: "",
    web: "",
    comentarios: "",
    oportunidadNombre: "",
    fechaCierre: "",
    probabilidad: "",
    monto: "",
  };

  const [form, setForm] = useState(initialState);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    step: null,
    data: [],
    payload: null,
  });
  const [loading, setLoading] = useState(false);

  const styles = {
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(255,255,255,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1055,
    },
    spinnerContainer: {
      textAlign: "center",
    },
  };

  useEffect(() => {
    if (!show) return;

    // CREACIÓN
    if (!isEditMode) {
      setForm({
        ...initialState,
        agenteVentas: {
          value: session.id,
          label: session.nombre,
        },
      });
      return;
    }

    // EDICIÓN
    if (record) {
      setForm({
        empresa: record.empresa
          ? { value: record.empresa.id, label: record.empresa.nombre }
          : null,

        razonSocial: record.razon_social || "",
        clave: record.clave || "",
        nombreComercial: record.nombre || "",
        rfc: record.rfc || "",

        zona: record.zona
          ? { value: record.zona.id, label: record.zona.descripcion }
          : null,

        grupoCliente: record.grupo
          ? { value: record.grupo.id, label: record.grupo.descripcion }
          : null,

        fuente: record.fuente
          ? { value: record.fuente.id, label: record.fuente.descripcion }
          : null,

        agenteVentas: record.agente_ventas
          ? {
              value: record.agente_ventas.id,
              label: record.agente_ventas.nombre,
            }
          : null,

        clasificacion: record.clasificacion || "",
        contactoNombre: record.nombre_contacto || "",
        email: record.email || "",
        telefono: record.telefono || "",
        extension: "",
        web: record.dir_internet || "",
        comentarios: record.comentarios || "",

        oportunidadNombre: "",
        fechaCierre: "",
        probabilidad: null,
        monto: "",
      });
    }
  }, [show, record, isEditMode]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const fieldLabels = {
    empresa: "Empresa",
    razonSocial: "Razón social",
    nombreComercial: "Nombre comercial",
    agenteVentas: "Agente de ventas",
  };

  const getRequiredFields = (isEditMode) => {
    return ["empresa", "razonSocial", "nombreComercial", "agenteVentas"];
  };

  const getMissingFields = (form, isEditMode) => {
    const missing = [];
    const requiredFields = getRequiredFields(isEditMode);

    requiredFields.forEach((field) => {
      const value = form[field];

      const isEmpty =
        value === undefined ||
        value === null ||
        value === "" ||
        (typeof value === "object" && !value.value && !value.length);

      if (isEmpty) {
        missing.push(field);
      }
    });

    return missing;
  };

  async function handleSubmit() {
    const missingFields = getMissingFields(form, isEditMode);
    if (missingFields.length > 0) {
      toast.warning(
        <div>
          <strong>Faltan por completar los siguientes campos:</strong>
          <br />
          <br />
          {missingFields.map((field) => (
            <div key={field}>• {fieldLabels[field]}</div>
          ))}
        </div>,
        { autoClose: 6000 },
      );

      return;
    }

    setLoading(true);

    const tieneOportunidad =
      form.oportunidadNombre ||
      form.fechaCierre ||
      form.probabilidad?.value ||
      Number(form.monto) > 0;

    const payload = {
      id: record?.id ?? null,
      nombre: form.nombreComercial,
      razon_social: form.razonSocial,
      clave: form.clave,
      rfc: form.rfc,

      id_empresa: form.empresa?.value || null,
      id_zona: form.zona?.value || null,
      id_clientes_grupo: form.grupoCliente?.value || null,
      id_fuente: form.fuente?.value || null,

      id_agente_ventas: form.agenteVentas?.value || null,

      clasificacion: form.clasificacion,
      nombre_contacto: form.contactoNombre,
      email: form.email,
      telefono: form.telefono,
      extension: form.extension,
      web: form.web,
      comentarios: form.comentarios,
      cliente_prospecto: 0,

      id_usuario: session.id,

      ...(tieneOportunidad && {
        oportunidad: {
          nombre: form.oportunidadNombre,
          nombre_oportunidad: form.oportunidadNombre,
          fecha_tentativa_cierre: form.fechaCierre,
          id_probabilidad_cierre: form.probabilidad?.value || null,
          id_agente_ventas: form.agenteVentas?.value || null,
          monto_proyecto: form.monto || 0,
        },
      }),
    };

    try {
      if (isEditMode) {
        await onSubmit(payload);

        toast.success("Cambios guardados correctamente");

        setLoading(false);
        onHide();
        return;
      }

      const res = await getClientesSimilares(form.nombreComercial);
      const similares = res?.data || [];

      setLoading(false);

      if (similares.length > 0) {
        setConfirmModal({
          show: true,
          type: "similares",
          data: similares,
          payload,
        });
        return;
      }

      // Si no hay similares → directo a confirmación final
      setConfirmModal({
        show: true,
        type: "confirmar",
        data: null,
        payload,
      });
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error("Error al validar clientes similares, intente de nuevo.");
      throw error;
    }
  }

  const calcularClave = async (empresaId) => {
    try {
      if (!empresaId) {
        handleChange("clave", "");
        return;
      }

      const res = await getClientes({
        page: 1,
        limit: 1,
        extraFilters: [
          {
            property: "id_empresa",
            value: empresaId,
            operator: "=",
            condition: "AND",
          },
        ],
        trash: "with",
      });

      const total = res?.total || 0;

      const consecutivo = 10000 + total;

      if (isEditMode && record?.clave && empresaId === record?.empresa?.id) {
        handleChange("clave", record.clave);
        return;
      }

      handleChange("clave", consecutivo);
    } catch (error) {
      console.error("Error calculando clave:", error);
      handleChange("clave", "");
    }
  };

  return (
    <Modal
      className="modal-backdrop-dark"
      show={show}
      onHide={onHide}
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditMode
            ? "EDITAR PROSPECTO " + form.nombreComercial
            : "NUEVO PROSPECTO"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ position: "relative" }}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            {/* ================= DATOS GENERALES ================= */}
            <Accordion.Header>Datos Generales</Accordion.Header>
            <Accordion.Body>
              <Form>
                {/* --- EMPRESA / RAZÓN SOCIAL --- */}
                <Row className="g-2">
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>
                        Empresa <span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <AsyncSelectERP
                        value={form.empresa}
                        loadOptionsApi={getEmpresas}
                        onChange={(option) => {
                          setForm((prev) => ({
                            ...prev,
                            empresa: option,
                            zona: null,
                          }));
                          if (option?.value) {
                            calcularClave(option.value);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>
                        Razón Social <span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control
                        value={form.razonSocial}
                        onChange={(e) =>
                          handleChange("razonSocial", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Clave</Form.Label>
                      <Form.Control value={form.clave} disabled />
                    </Form.Group>
                  </Col>
                </Row>

                {/* --- NOMBRE COMERCIAL --- */}
                <Row className="g-2 mt-1">
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label>
                        Nombre Comercial{" "}
                        <span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <Form.Control
                        value={form.nombreComercial}
                        onChange={(e) =>
                          handleChange("nombreComercial", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* --- RFC / ZONA --- */}
                <Row className="g-2 mt-1">
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>RFC</Form.Label>
                      <Form.Control
                        value={form.rfc}
                        minlength="10"
                        maxlength="13"
                        onChange={(e) => handleChange("rfc", e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Zona del Prospecto</Form.Label>
                      <AsyncSelectERP
                        value={form.zona}
                        loadOptionsApi={getZonas}
                        onChange={(option) => handleChange("zona", option)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* --- GRUPO / FUENTE --- */}
                <Row className="g-2 mt-1">
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Grupo de cliente</Form.Label>
                      <AsyncSelectERP
                        value={form.grupoCliente}
                        loadOptionsApi={getGruposCliente}
                        onChange={(option) =>
                          handleChange("grupoCliente", option)
                        }
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Fuente</Form.Label>
                      <AsyncSelectERP
                        value={form.fuente}
                        loadOptionsApi={getFuentesProspecto}
                        onChange={(option) => handleChange("fuente", option)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* --- AGENTE --- */}
                <Row className="g-2 mt-1">
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label>
                        Agente de Ventas{" "}
                        <span style={{ color: "red" }}> *</span>
                      </Form.Label>
                      <AsyncSelectERP
                        value={form.agenteVentas}
                        loadOptionsApi={getAgentesVentas}
                        onChange={(option) =>
                          handleChange("agenteVentas", option)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* ================= CLASIFICACIÓN ================= */}
                <h5 className="mt-4">CLASIFICACIÓN</h5>
                <Row className="g-2">
                  <Col xs={12} md={4}>
                    <Form.Group>
                      <Form.Label>Clasificación</Form.Label>
                      <Form.Control
                        value={form.clasificacion}
                        onChange={(e) =>
                          handleChange("clasificacion", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* ================= CONTACTO ================= */}
                <h5 className="mt-4">CONTACTO</h5>

                <Row className="g-2">
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Nombre de contacto</Form.Label>
                      <Form.Control
                        value={form.contactoNombre}
                        onChange={(e) =>
                          handleChange("contactoNombre", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="ejemplo@dominio.com"
                        value={form.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="g-2 mt-1">
                  <Col xs={12} md={8}>
                    <Form.Group>
                      <Form.Label>Teléfono</Form.Label>
                      <Form.Control
                        value={form.telefono}
                        maxLength={12}
                        minLength={10}
                        onChange={(e) =>
                          handleChange("telefono", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={4}>
                    <Form.Group>
                      <Form.Label>Extensión</Form.Label>
                      <Form.Control
                        value={form.extension}
                        onChange={(e) =>
                          handleChange("extension", e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="g-2 mt-1">
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label>Dirección de Internet</Form.Label>
                      <Form.Control
                        placeholder="http://ejemplo.com"
                        value={form.web}
                        onChange={(e) => handleChange("web", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* ================= COMENTARIOS ================= */}
                <h5 className="mt-4">COMENTARIOS</h5>
                <Form.Group>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={form.comentarios}
                    onChange={(e) =>
                      handleChange("comentarios", e.target.value)
                    }
                  />
                </Form.Group>
              </Form>
            </Accordion.Body>
          </Accordion.Item>

          {/* ================= OPORTUNIDAD ================= */}
          {!isEditMode && (
            <Accordion.Item eventKey="1">
              <Accordion.Header>Oportunidad</Accordion.Header>
              <Accordion.Body>
                <Form>
                  <Row className="g-2">
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label>Nombre de la Oportunidad</Form.Label>
                        <Form.Control
                          value={form.oportunidadNombre}
                          onChange={(e) =>
                            handleChange("oportunidadNombre", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label>Fecha Tentativa de Cierre</Form.Label>
                        <Form.Control
                          type="date"
                          value={form.fechaCierre}
                          onChange={(e) =>
                            handleChange("fechaCierre", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-2 mt-1">
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label>
                          Probabilidad de Cierre{" "}
                          <span style={{ color: "red" }}> *</span>
                        </Form.Label>
                        <AsyncSelectERP
                          value={form.probabilidad}
                          loadOptionsApi={getProbabilidadesCierre}
                          onChange={(option) =>
                            handleChange("probabilidad", option)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label>Monto de la Oportunidad</Form.Label>
                        <Form.Control
                          value={form.monto}
                          onChange={(e) =>
                            handleChange("monto", e.target.value)
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Accordion.Body>
            </Accordion.Item>
          )}
        </Accordion>
        <WdowConfirm
          show={confirmModal.show}
          onHide={() => setConfirmModal({ show: false })}
          onConfirm={async () => {
            if (confirmModal.step === "similares") {
              setConfirmModal({
                show: true,
                step: "confirmar",
                data: [],
                payload: confirmModal.payload,
              });
            } else {
              try {
                setLoading(true);
                setConfirmModal({ show: false });
                const response = await onSubmit(confirmModal.payload);
                if (response?.cliente?.oportunidad) {
                  onCreateSeguimiento({
                    cliente: response.cliente,
                    oportunidad: response.cliente.oportunidad,
                  });
                } else {
                  onHide();
                }
                toast.success("Se ha creado correctamente al prospecto.");
              } catch (e) {
                console.error(e);
                toast.error("Error al crear el prospecto");
                throw e;
              } finally {
                setLoading(false);
              }
            }
          }}
          title={
            confirmModal.step === "similares"
              ? "Posibles duplicados"
              : "Confirmar creación"
          }
          message={
            confirmModal.step === "similares"
              ? "¿Deseas continuar con la creación?"
              : `¿Deseas crear "${form.nombreComercial}"?`
          }
          type={confirmModal.step === "similares" ? "warning" : "confirm"}
          data={confirmModal.data}
        />
        {loading && (
          <div style={styles.overlay}>
            <div style={styles.spinnerContainer}>
              <Spinner label="Guardando…" />
              <div style={{ marginTop: 10, fontWeight: 500 }}>Guardando...</div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>

        <Button variant="success" onClick={handleSubmit} disabled={loading}>
          {isEditMode ? "Actualizar Prospecto" : "Crear Prospecto"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
